/*
 * ---------------------------------------------------------------------------------------------------------------------
 * CHARGEMENT DIFFÉRÉ DES BLOCS DE CONVERSION (préconisation SEO Visicrea — juillet 2026)
 * ---------------------------------------------------------------------------------------------------------------------
 *
 * Les sections FAQ, témoignages, bandeau services, « Ils performent chez WIDE » et newsletter n'écrivent
 * plus rien dans le HTML initial des fiches produit, des collections et des pages campus. Elles y déposent
 * un simple <deferred-section section-id="…"></deferred-section>.
 *
 * Ce script les charge via la Section Rendering API de Shopify à la PREMIÈRE INTERACTION du visiteur :
 * mouvement de souris, appui du doigt, touche du clavier, molette ou défilement.
 *
 * `wheel` et `scroll` ont été ajoutés à la demande de Visicrea (août 2026). Réserve documentée :
 * `wheel` n'est émis que par une action matérielle réelle (molette / trackpad), mais `scroll` est
 * émis par TOUT défilement, y compris programmatique — or le moteur de rendu de Google fait défiler
 * les pages. Retirer 'scroll' du tableau ci-dessous suffit à revenir à un déclenchement strictement
 * humain.
 *
 * Voir snippets/deferred-blocks-mode.liquid pour la logique côté serveur.
 */

(function () {
  'use strict';

  /* Doit rester identique à `deferred_page_token` dans snippets/deferred-blocks-mode.liquid.
     Valeur sentinelle : ne correspond à aucune pagination réelle du site. */
  var PAGE_TOKEN = '999999';

  /* 'wheel' et 'scroll' : ajout Visicrea, voir la réserve en en-tête de fichier. */
  var TRIGGER_EVENTS = ['mousemove', 'pointerdown', 'touchstart', 'keydown', 'wheel', 'scroll'];

  var pending = [];
  var triggered = false;

  function sectionUrl(sectionId) {
    var url = new URL(window.location.href);
    url.searchParams.set('page', PAGE_TOKEN);
    url.searchParams.set('section_id', sectionId);
    return url.toString();
  }

  /*
   * Les <script> produits par DOMParser sont inertes : le navigateur ne les exécute pas une fois
   * insérés. On les recrée pour restituer le comportement d'origine (carrousel des témoignages).
   * Le JSON-LD n'a rien à exécuter.
   */
  function reviveScripts(root) {
    var scripts = root.querySelectorAll('script');

    for (var i = 0; i < scripts.length; i++) {
      var original = scripts[i];

      if (original.type === 'application/ld+json') {
        continue;
      }

      var revived = document.createElement('script');

      for (var j = 0; j < original.attributes.length; j++) {
        revived.setAttribute(original.attributes[j].name, original.attributes[j].value);
      }

      revived.textContent = original.textContent;
      original.replaceWith(revived);
    }
  }

  function load(element) {
    var sectionId = element.getAttribute('section-id');

    if (!sectionId) {
      return;
    }

    fetch(sectionUrl(sectionId), { priority: 'low' })
      .then(function (response) {
        return response.ok ? response.text() : Promise.reject(response.status);
      })
      .then(function (html) {
        var wrapperId = 'shopify-section-' + sectionId;
        var current = document.getElementById(wrapperId);

        if (!current) {
          return;
        }

        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.getElementById(wrapperId) || parsed.body.firstElementChild;

        /*
         * La section n'a rien rendu (métachamp vide, par exemple) : on retire le placeholder plutôt
         * que de laisser un conteneur masqué dans la page.
         */
        if (!fresh) {
          current.remove();
          return;
        }

        var imported = document.importNode(fresh, true);

        /* Même instance de section des deux côtés : le wrapper conserve son id, et les <style>
           internes qui ciblent #shopify-section-<id> restent valides. */
        current.replaceWith(imported);
        reviveScripts(imported);
      })
      .catch(function () {
        /* Échec réseau : on n'affiche rien, la page reste utilisable. */
      });
  }

  function trigger() {
    if (triggered) {
      return;
    }

    triggered = true;

    for (var i = 0; i < TRIGGER_EVENTS.length; i++) {
      document.removeEventListener(TRIGGER_EVENTS[i], trigger, true);
    }

    var queue = pending.splice(0, pending.length);

    for (var k = 0; k < queue.length; k++) {
      load(queue[k]);
    }
  }

  for (var i = 0; i < TRIGGER_EVENTS.length; i++) {
    document.addEventListener(TRIGGER_EVENTS[i], trigger, { capture: true, passive: true, once: true });
  }

  var DeferredSection = class extends HTMLElement {
    connectedCallback() {
      if (triggered) {
        load(this);
      } else {
        pending.push(this);
      }
    }
  };

  if (!window.customElements.get('deferred-section')) {
    window.customElements.define('deferred-section', DeferredSection);
  }
})();
